module.exports = __webpack_public_path__ + "img/inu_gallery2.fd3c64fd.jpg";